'use strict';

var _require = require('./utils/flatten'),
    flatten = _require.flatten;

var createTransition = require('./utils/transition');

var combineSubscribers = function combineSubscribers(subscriberMap) {
  return function (transition, extraArgument) {
    return flatten(Object.keys(subscriberMap).map(function (key) {
      return transition.from[key] !== transition.to[key] && subscriberMap[key] ? [].concat(subscriberMap[key](createTransition(transition.from[key], transition.to[key]), extraArgument)) : [];
    }));
  };
};

module.exports = combineSubscribers;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/combineSubscribers.js
// module id = 274
// module chunks = 0